import React from 'react';
// layout
import ManagementLayout from '../layout/management';
// components
import Dropdown from '../components/dropdown';

class Applicants extends React.Component {
  render() {
    return (
        <ManagementLayout>
            <div className="col-md-9">
              <h1 className="title">Applicants <span><button className="btn btn-sm btn-primary">Filter</button></span></h1>
              <Dropdown></Dropdown>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">First</th>
                    <th scope="col">Last</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </ManagementLayout>
      )
  }
}

export default Applicants;